// Agent Props workaround; don't want to make Agent as a package
type AgentProps = {
  canvasAppId: string
  eventListener?: (event: CanvasEventPostMessage) => void
  frameParent?: HTMLElement
  fullScreen?: boolean
  locale?: string
  sessionId?: string
  token: string
  customContext?: Record<string, any>
  authClientId?: any
  debug?: boolean
}

export enum CanvasAppEvent {
  CHECKOUT = 'checkout',
  CLOSE = 'close',
  COLLECT = 'collect',
  ERROR = 'error',
  EXPIRED = 'expired',
  INIT = 'init',
  NATIVE_CATALOG_REQUEST = 'native_catalog_request',
  NATIVE_CHECKOUT_REQUEST = 'native_checkout_request',
  NAVIGATE = 'navigate',
  READY = 'ready',
  RESIZE = 'resize',
}

export type CanvasEventPostMessage = {
  eventType: CanvasAppEvent
  [key: string]: any
}

export type PushMessageData = {
  id: string
  topic?: string
  payload: Record<string, any>
}
